/**
 * Gift With Purchase (GWP) Handler
 * Manages gift product selection and removal in cart
 * Extracted and refactored from inline cart-drawer.liquid script
 */

class GiftWithPurchaseHandler {
  constructor() {
    console.log('[GWP Handler] Constructor called');
    
    // Look for both button selectors to handle different markup
    this.buttons = document.querySelectorAll('.btn-gwp, .gwp-btn .btn');
    this.items = document.querySelectorAll('.gwp-item');
    this.activeButton = null;
    
    console.log('[GWP Handler] Found elements:', {
      buttons: this.buttons.length,
      items: this.items.length,
      container: document.querySelector('.gwp-upsell-container') ? 'exists' : 'missing',
      splideElement: document.querySelector('.splide-cart-drawer') ? 'exists' : 'missing'
    });
    
    this.init();
  }
  
  init() {
    console.log('[GWP Handler] Init called');
    
    // Initialize Splide carousel if it exists
    this.initializeSplide();
    
    // Bind event listeners
    this.bindEvents();
    
    // Check initial cart state
    this.checkCartForGiftItem();
    
    console.log('[GWP Handler] Initialization complete');
  }
  
  initializeSplide() {
    console.log('[GWP Handler] Checking for Splide carousel...');
    
    const splideElement = document.querySelector('.splide-cart-drawer');
    if (splideElement && typeof Splide !== 'undefined') {
      console.log('[GWP Handler] Splide element found, initializing carousel');
      
      // Check if already initialized
      if (!splideElement.classList.contains('is-initialized')) {
        try {
          const splide = new Splide(splideElement, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            arrows: true,
            breakpoints: {
              768: {
                perPage: 2
              },
              480: {
                perPage: 1
              }
            }
          });
          
          splide.mount();
          // ADD THE CLASS THAT MAKES IT VISIBLE
          splideElement.classList.add('is-initialized');
          console.log('[GWP Handler] Splide carousel mounted and is-initialized class added');
        } catch (error) {
          console.error('[GWP Handler] Error initializing Splide:', error);
        }
      } else {
        console.log('[GWP Handler] Splide already initialized');
      }
    } else {
      console.log('[GWP Handler] Splide not found or library not loaded', {
        element: splideElement ? 'found' : 'missing',
        library: typeof Splide !== 'undefined' ? 'loaded' : 'missing'
      });
    }
  }
  
  bindEvents() {
    console.log('[GWP Handler] Binding events');
    
    // Add gift button clicks - handle both button types
    document.addEventListener('click', (e) => {
      if (e.target.matches('.btn-gwp') || e.target.matches('.gwp-btn .btn')) {
        console.log('[GWP Handler] Add button clicked', e.target);
        e.preventDefault();
        this.handleAddGift(e);
      }
      
      // Remove gift button clicks
      if (e.target.matches('.gwp_remove')) {
        console.log('[GWP Handler] Remove button clicked');
        e.preventDefault();
        this.handleRemoveGift(e);
      }
    });
    
    // Listen for cart drawer events
    document.addEventListener('drawerOpen.CartDrawer', () => {
      console.log('[GWP Handler] Cart drawer opened');
      setTimeout(() => {
        this.initializeSplide(); // Re-init Splide when drawer opens
        this.checkCartForGiftItem();
      }, 100);
    });
    
    // Listen for cart threshold events
    document.addEventListener('cart:update:0', () => {
      console.log('[GWP Handler] Cart update:0 event');
      this.handleCartEmpty();
    });
    document.addEventListener('cart:low', () => {
      console.log('[GWP Handler] Cart low event');
      this.handleCartLow();
    });
    document.addEventListener('cart:high', () => {
      console.log('[GWP Handler] Cart high event');
      this.handleCartHigh();
    });
  }
  
  /**
   * Refresh button references (in case DOM has changed)
   */
  refreshButtons() {
    console.log('[GWP Handler] Refreshing button references');
    this.buttons = document.querySelectorAll('.btn-gwp, .gwp-btn .btn');
    this.items = document.querySelectorAll('.gwp-item');
    console.log('[GWP Handler] After refresh:', {
      buttons: this.buttons.length,
      items: this.items.length
    });
    
    // Also reinitialize Splide if needed
    this.initializeSplide();
  }
  
  /**
   * Enable all GWP buttons
   */
  enableButtons() {
    this.refreshButtons(); // Refresh in case DOM changed
    this.buttons.forEach(btn => {
      btn.textContent = 'Add';
      btn.removeAttribute('disabled');
    });
  }
  
  /**
   * Disable all GWP buttons
   */
  disableButtons() {
    this.refreshButtons(); // Refresh in case DOM changed
    this.buttons.forEach(btn => {
      btn.textContent = 'Add';
      btn.setAttribute('disabled', '');
    });
  }
  
  /**
   * Reset all GWP items visual state
   */
  resetItemStates() {
    this.items.forEach(item => {
      item.classList.remove('not_selected', 'selected');
    });
  }
  
  
  /**
   * Update UI after gift selection
   */
  updateGiftSlider() {
    this.disableButtons();
    
    if (this.activeButton) {
      this.activeButton.textContent = 'Added';
      
      // Update visual states
      this.items.forEach(item => {
        item.classList.add('not_selected');
      });
      
      const activeItem = this.activeButton.closest('.gwp-item');
      if (activeItem) {
        activeItem.classList.remove('not_selected');
        activeItem.classList.add('selected');
      }
    }
  }
  
  /**
   * Add gift product to cart
   */
  handleAddGift(e) {
    // Find the button that was clicked (could be .btn-gwp or .btn)
    this.activeButton = e.target.closest('.btn-gwp') || e.target.closest('.btn');
    const variantId = this.activeButton.dataset.gwp_product_id;
    
    if (!variantId) {
      console.error('[GWP Handler] No variant ID found');
      return;
    }
    
    console.log('[GWP Handler] Adding gift product:', variantId);
    
    const productData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          '_gift_with_purchase': 'Gift with purchase!'
        }
      }]
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(productData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('[GWP Handler] Gift added successfully');
      this.updateGiftSlider();
      
      // Trigger cart rebuild
      document.dispatchEvent(new Event('cart:build'));
    })
    .catch(error => {
      console.error('[GWP Handler] Error adding gift:', error);
    });
  }
  
  /**
   * Remove gift product from cart
   */
  handleRemoveGift(e) {
    const removeButton = e.target;
    // Look for either .cart-gwp-item or .cart__item with data-gwp_prod
    const giftItem = removeButton.closest('.cart-gwp-item') || removeButton.closest('[data-gwp_prod]');
    
    if (!giftItem) {
      console.error('[GWP Handler] No gift item found to remove', {
        button: removeButton,
        parent: giftItem
      });
      return;
    }
    
    // Cart items have data-key attribute which is the line item key
    const lineKey = giftItem.dataset.key;
    
    if (!lineKey) {
      console.error('[GWP Handler] No line key found on gift item');
      return;
    }
    
    console.log('[GWP Handler] Removing gift product with key:', lineKey);
    
    // Use the same format as theme.js changeItem
    const updateData = {
      id: lineKey,
      quantity: 0
    };
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('[GWP Handler] Gift removed successfully', data);
      
      // Trigger cart rebuild
      document.dispatchEvent(new Event('cart:build'));
      
      // Reset UI after a delay to allow cart to rebuild
      setTimeout(() => {
        this.refreshButtons(); // Refresh button references
        this.enableButtons();  // Enable all buttons
        this.resetItemStates(); // Reset visual states
        console.log('[GWP Handler] Buttons re-enabled after removal');
      }, 500);
    })
    .catch(error => {
      console.error('[GWP Handler] Error removing gift:', error);
      // Still try to enable buttons on error
      this.enableButtons();
    });
  }
  
  /**
   * Check if cart already contains a gift item
   */
  checkCartForGiftItem() {
    const cartGiftItem = document.querySelector('.cart-gwp-item');
    
    if (cartGiftItem) {
      console.log('[GWP Handler] Gift item found in cart');
      const giftVariantId = cartGiftItem.dataset.gwp_prod;
      
      this.buttons.forEach(btn => {
        btn.textContent = 'Add';
        btn.setAttribute('disabled', '');
        
        if (btn.dataset.gwp_product_id === giftVariantId) {
          btn.textContent = 'Added';
          btn.closest('.gwp-item')?.classList.add('selected');
        } else {
          btn.closest('.gwp-item')?.classList.add('not_selected');
        }
      });
      
      return true;
    }
    
    console.log('[GWP Handler] No gift item in cart');
    return false;
  }
  
  /**
   * Clear any existing gift item when threshold not met
   */
  clearGiftItem() {
    console.log('[GWP Handler] Clearing gift item');
    this.enableButtons();
    this.resetItemStates();
    
    const hasGift = this.checkCartForGiftItem();
    if (hasGift) {
      const cartGiftItem = document.querySelector('.cart-gwp-item');
      if (cartGiftItem && cartGiftItem.dataset.gwp_prod) {
        const updateData = {
          updates: {
            [cartGiftItem.dataset.gwp_prod]: 0
          }
        };
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updateData)
        })
        .then(response => response.json())
        .then(data => {
          console.log('[GWP Handler] Gift item cleared');
          document.dispatchEvent(new Event('cart:build'));
        })
        .catch(error => {
          console.error('[GWP Handler] Error clearing gift:', error);
        });
      }
    }
  }
  
  /**
   * Handle cart empty state
   */
  handleCartEmpty() {
    console.log('[GWP Handler] Cart is empty');
    this.clearGiftItem();
    
    const gwpContainer = document.querySelector('.gwp-upsell-container');
    if (gwpContainer) {
      gwpContainer.style.display = 'none';
    }
  }
  
  /**
   * Handle cart below threshold
   */
  handleCartLow() {
    console.log('[GWP Handler] Cart below threshold');
    this.clearGiftItem();
  }
  
  /**
   * Handle cart above threshold
   */
  handleCartHigh() {
    console.log('[GWP Handler] Cart above threshold');
    // Don't hide it! The threshold events just tell us about cart value
    // The container visibility should be controlled by CSS/Liquid based on settings
    setTimeout(() => {
      this.initializeSplide(); // Make sure Splide is initialized
      this.refreshButtons();
    }, 100);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('[GWP Handler] DOMContentLoaded event fired');
  
  // Check if GWP container exists
  const container = document.querySelector('.gwp-upsell-container');
  console.log('[GWP Handler] GWP container:', container ? 'found' : 'not found');
  
  if (container) {
    console.log('[GWP Handler] Creating new GiftWithPurchaseHandler instance');
    window.gwpHandler = new GiftWithPurchaseHandler();
  } else {
    console.log('[GWP Handler] Skipping initialization - no GWP container found');
  }
});

// Also reinitialize when cart drawer is opened or cart is rebuilt
document.addEventListener('cart:build', function() {
  console.log('[GWP Handler] cart:build event fired');
  
  setTimeout(function() {
    const container = document.querySelector('.gwp-upsell-container');
    console.log('[GWP Handler] After cart:build - container:', container ? 'found' : 'not found');
    
    if (container && !window.gwpHandler) {
      console.log('[GWP Handler] Creating handler after cart:build');
      window.gwpHandler = new GiftWithPurchaseHandler();
    } else if (window.gwpHandler) {
      console.log('[GWP Handler] Handler exists, refreshing after cart:build');
      window.gwpHandler.refreshButtons();
      window.gwpHandler.checkCartForGiftItem();
    }
  }, 500); // Give time for DOM to update
});

// Reinitialize when drawer opens
document.addEventListener('drawerOpen.CartDrawer', function() {
  console.log('[GWP Handler] drawerOpen.CartDrawer event fired');
  
  setTimeout(function() {
    const container = document.querySelector('.gwp-upsell-container');
    console.log('[GWP Handler] After drawer open - container:', container ? 'found' : 'not found');
    
    if (container && !window.gwpHandler) {
      console.log('[GWP Handler] Creating handler after drawer open');
      window.gwpHandler = new GiftWithPurchaseHandler();
    } else if (window.gwpHandler) {
      console.log('[GWP Handler] Handler exists, refreshing after drawer open');
      window.gwpHandler.refreshButtons();
      window.gwpHandler.checkCartForGiftItem();
    }
  }, 500);
});

// Log when cart is updated
document.addEventListener('cart:updated', function() {
  console.log('[GWP Handler] cart:updated event fired');
});